import { PropsWithChildren } from 'react';
import { IonInput } from '@ionic/react';
import { Controller, useForm } from 'react-hook-form';
import Theme from '../../../../components-library/Theme';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../store/types';
import { REDUX_STORE_SLICES } from '../../../../services/exports/Constants';
import { OtpSchema, otpSchema } from './schema';
import { zodResolver } from '@hookform/resolvers/zod';
import useAuth from '../../../../hooks/global/useAuth';
import Button from '../../components/buttons/Button';
import { useTranslation } from 'react-i18next';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';
import { LoginData } from '../../../../services/auth/AuthorizationManager';

interface OtpFormProps extends PropsWithChildren {
  onSuccess: () => void;
  defaultValues: OtpSchema;
  onResendClick: () => void;
}

const OtpForm = ({ onSuccess, defaultValues, onResendClick, children }: OtpFormProps) => {
  const { login, loading } = useAuth();
  const companyId = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.id);
  const form = useForm<OtpSchema>({
    resolver: zodResolver(otpSchema),
    defaultValues: {
      phone_number: defaultValues?.phone_number,
      company_id: companyId,
      password: defaultValues?.password ?? '',
    },
  });
  const { isMobileApp } = useMobileApp();
  const onSubmitForm = (data: OtpSchema) => {
    return login({ ...data, ...(isMobileApp && { utm_source: 'mobile_app' }) } as LoginData).then(onSuccess);
  };
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:OtpForm' });

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmitForm)} className={!children ? 'pb-sm' : ''}>
        <Controller
          name="password"
          control={form.control}
          render={({ field }) => (
            <IonInput
              className="border rounded-lg !px-4"
              style={{ '--placeholder-color': Theme.color.mobile.tertiary }}
              placeholder={t('placeholders.code')}
              onIonChange={field.onChange}
              inputmode="numeric"
              {...field}
            />
          )}
        />
        <Button title={t('buttons.login')} type="submit" loading={loading} expand="block" className="mt-sm -ml-[1px]" />
        {children}
      </form>
      <div className="border-t-sm pt-sm space-y-sm">
        <div className="text-center text-brand-text-secondary">
          <p className="">{t('labels.not_receive_code')}</p>
        </div>
        <Button title={t('buttons.resend_code')} expand="block" design="secondary" onClick={onResendClick} />
      </div>
    </>
  );
};

export default OtpForm;
